<mat-card appearance="outlined" class="card-widget marB8 card-div">
  <div>
    <label class="mainBodyTxt3 GreyLight d-block" [attr.name]="title">{{ title }}</label>
    <hr class="lineStyle marT8" />
    <div class="row" style="height: 67px">
      <div class="col-12 div-align">
        <mat-card-content class="matc">
          <h2 class="h2Header GreyDarkest" id="InflowCount">{{ data }}</h2>
          <span class="mainBodyTxt GreyLight d-block marT4"></span>
        </mat-card-content>
      </div>
    </div>
  </div>
</mat-card>
